<igx-grid #gridTiposInsumos [width]="'100%'" [height]="'100%'" [locale]="localGrid"
  [allowFiltering]="true" [filterMode]="'excelStyleFilter'" [rowSelection]="activarBotones ? rowSelectionSingle : rowSelectionMultiple" [selectRowOnClick]="false" [igxGridState]="optionsGridLocal" (columnInit)="onColumnInit($event)"
  [rowEditable]="true" [primaryKey]="'IdTipoInsumo'" (cellEditEnter)="cellEditEnter($event)" (rowEditEnter)="rowEditEnter($event)" (rowEditExit)="rowEditExit()"
  (rowEditDone)="addUpdateTipoInsumo($event)" (rowEdit)="validarTipoInsumo($event)" (cellEdit)="edicionCelda($event)" (contextMenu)="menuContextual($event)" (window:click)="disableContextMenu()" [moving]="true"
  [sortingOptions]="sortingOptions" (keydown)="customKeydown($event)" paste-handler-neodata (onDataProcessed)="datosPegadosDesdeExcel($event)" (rowSelectionChanging)="handleRowSelection()">
  <igx-grid-toolbar>
    <igx-grid-toolbar-title>
      <app-filtro-general-moderno #filtroGeneral descripcionLabel="{{ 'MENSAJES.GRALS.ETIQUETA_FILTRO_GRAL' | translate}}" (enterPalabra)="filterInput($event)" (limpiarPalabras)="clearInput()" />
    </igx-grid-toolbar-title>
    <igx-grid-toolbar-actions>
      <igx-grid-toolbar-hiding />
      <igx-grid-toolbar-pinning />
      <app-mas-opciones-grid #masOpcionesG [arrayDatosAVer]="[0, 1, 2, 3, 6]" (opcionSeleccionada)="onSelectionDropDown($event)" />
    </igx-grid-toolbar-actions>
  </igx-grid-toolbar>
  <ng-template igxSortHeaderIcon>
    <igx-icon>north</igx-icon>
  </ng-template>
  <ng-template igxSortAscendingHeaderIcon>
    <igx-icon>north</igx-icon>
  </ng-template>
  <ng-template igxSortDescendingHeaderIcon>
    <igx-icon>south</igx-icon>
  </ng-template>
  <ng-template igxExcelStyleHeaderIcon>
    <igx-icon>filter_alt</igx-icon>
  </ng-template>
  <igx-column field="TipoInsumo" header="{{ 'GRIDS.TIPOS_INSUMOS.COL_TIPO' | translate}}" [dataType]="'number'" width="100px" [sortable]="true" [resizable]="true" [cellStyles]="cellStyles">
    <ng-template igxHeader #tipoInsumoHeaderTemplate let-column>
      <div title="{{ 'GRIDS.TIPOS_INSUMOS.COL_TIPO' | translate}}" class="header-required">{{column.header + '*'}}</div>
    </ng-template>
  </igx-column>
  <igx-column field="DescripcionTipoInsumo" header="{{ 'GRIDS.TIPOS_INSUMOS.COL_DESCRIPCION' | translate}}" [dataType]="'string'" width="220px" [sortable]="true" [resizable]="true" [hasSummary]="true" [summaries]="'filasSummary' | summaryPipeNeo">
    <ng-template igxHeader #descripcionTipoInsumoHeaderTemplate let-column>
      <div title="{{ 'GRIDS.TIPOS_INSUMOS.COL_DESCRIPCION' | translate}}" class="header-required">{{column.header + '*'}}</div>
    </ng-template>
    <ng-template igxCellEditor #descripcionTipoInsumoEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="DescripcionTipoInsumo" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true" (keydown)="stopPropagationPegado($event)" type="text" maxlength="40"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
<!--Acciones Editar, Agregar y Borrar-->
@if (showActionStrip) {
  <igx-action-strip #actionstrip>
    <button title="{{ 'TOOLTIPS.NUEVO_REGISTRO' | translate}}" igxButton="fab" (buttonClick)="accionStripRowBtn(actionstrip.context, 1)">
      <igx-icon>add</igx-icon>
    </button>
    @if (noPermitirBorrarMod(actionstrip.context)) {
      <button title="{{ 'TOOLTIPS.EDITAR_REGISTRO' | translate}}" igxButton="fab" igxRipple style="margin-left: 5px" (buttonClick)='startEdit(actionstrip.context)'>
        <igx-icon>edit</igx-icon>
      </button>
      <button title="{{ 'TOOLTIPS.BORRAR_REGISTRO' | translate}}" igxButton="fab" style="margin-left: 5px" (buttonClick)="accionStripRowBtn(actionstrip.context, 2)">
        <igx-icon>delete</igx-icon>
      </button>
    }
  </igx-action-strip>
}
</igx-grid>
@if (verContextMenu) {
  <app-context-menu-generico [cellMenuContextual]="cellMenuContextaul" [menusOpciones]="menus" [lengthMenu]="lengthMenu" [size]="sizeMenu" [subMenusOpciones]="subMenusOpciones"
                             (accionSeleccionada)="accionSeleccionada($event)" [x]="contextmenuX" [y]="contextmenuY" />
}
